<!--
 * @Author: your name
 * @Date: 2022-01-12 15:42:56
 * @LastEditTime: 2022-01-13 09:47:16
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \ant-design-vue-jeecg\src\views\modules\synergy\project\task\kanban\gantt\index.vue
-->
<template>
  <div id="gantt_here" style="width: 100%; height: 600px"></div>
</template>
<script>
import { gantt } from '@/components/thirdpart/gantt/dhtmlxgantt'
import '@/components/thirdpart/gantt/dhtmlxgantt.css'

export default {
  name: 'gantt',
  data() {
    return {
      title: '甘特图',
    }
  },
  mounted() {
    gantt.i18n.setLocale('cn')
    gantt.i18n.setLocale({
    labels: {
        new_task: "新任务"
    }
});
    gantt.config.columns = [
      { name: 'text', tree: true, width: '*', resize: true },
      { name: 'start_date', align: 'center', resize: true },
      // { name: 'duration', align: 'center' },
      { name: 'assignner', align: 'center', label: '负责人' },
      { name: 'add', width: 44 },
    ]
    gantt.init('gantt_here')

    gantt.parse({
      data: [
        {
          id: 1,
          text: 'Project #2',
          start_date: '01-04-2018',
          assignner: '姚曌',
          duration: 18,
          progress: 0.4,
          open: true,
        },
        { id: 2, text: 'Task #1', start_date: '02-04-2018', assignner: '严浩', duration: 8, progress: 0.6, parent: 1 },
        { id: 3, text: 'Task #2', start_date: '11-04-2018', assignner: '周浩', duration: 8, progress: 0.6, parent: 1 },
      ],
      links: [
        { id: 1, source: 1, target: 2, type: '1' },
        { id: 2, source: 2, target: 3, type: '0' },
      ],
    })
  },
}
</script>